export default __webpack_public_path__ + "static/DomaineTextWeb-Regular-56fae0482a065227c8d29a6434aa4e3f.eot";